import React, { useMemo } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
  Badge,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";
import Select from "react-select";

import MainLayout from "../../layouts/MainLayout";
import { PageHeader } from "../../components/PageHeader";
import { MonthlyPlans } from "./MonthlyPlans";
import { StoragePlans } from "./StoragePlans";
import { OneTimePayment } from "./OneTimePayment";
import ImagePlaceholder from "../../images/templates/placeholder.jpg";

const trendingTopics = ["RH", "Laboral"];

function Plans() {
  const { t } = useTranslation();
  const { path, url } = useRouteMatch();

  const tabs = useMemo(() => {
    return [
      {
        id: 1,
        path: `${url}/monthly`,
        label: t("Plans.tabs.0"),
      },
      // {
      //     id: 2,
      //     path: `${url}/storage`,
      //     label: t('Almacenamiento')
      // },
      {
        id: 3,
        path: `${url}/one-time`,
        label: t("Plans.tabs.1"),
      },
    ];
  }, [t, url]);

  return (
    <MainLayout className="">
      <PageHeader className="bg-white pb-0 pt-4">
        <PageHeader.Title>{t("Plans.title", { count: 2 })}</PageHeader.Title>
        <PageHeader.Tabs tabs={tabs} />
      </PageHeader>
      <Switch>
        <Route path={`${path}/monthly`}>
          <MonthlyPlans />
        </Route>
        {/* <Route path={`${path}/storage`}>
                        <StoragePlans />
                    </Route> */}
        <Route path={`${path}/one-time`}>
          <OneTimePayment />
        </Route>
        <Redirect from={path} to={`${path}/monthly`} />
      </Switch>
    </MainLayout>
  );
}

export default Plans;
